import { useMemo } from 'react'

import { useActionCableChannel } from '@/providers/cable'
import { CustomTokenInfo } from '@/utils/helpers'

import { orderTokensLikeBE } from './utils'

export type SocketPrice = {
  price: number
  time: Date
  volume: number
}

const usePriceSocket = (tokenA: CustomTokenInfo, tokenB: CustomTokenInfo) => {
  const pairParams = useMemo(
    () => ({
      pair: orderTokensLikeBE(tokenA, tokenB).map(({ symbol }) => symbol).join('/').toLowerCase(),
    }),
    [tokenA, tokenB],
  )

  const { lastMessage, ...rest } = useActionCableChannel<{ t: string; p: number; v: number }>(
    'TradingView::Channel',
    pairParams,
  )

  const formattedLastMessage = useMemo(
    () =>
      lastMessage && {
        ...lastMessage,
        data: {
          price: lastMessage.data.p,
          time: new Date(lastMessage.data.t),
          volume: lastMessage.data.v,
        } as SocketPrice,
      },
    [lastMessage],
  )

  return {
    ...rest,
    lastMessage: formattedLastMessage,
  }
}

export default usePriceSocket
